import qs from 'qs';
import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deleteSegment${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
export const useMutationDeleteSegment = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    segmentId: number;
}
